import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'web/service_order_chat_message';

export default {
  async search(serviceOrderId, queryParams) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}`, queryParams);
    return api.get(url);
  },
  async create(serviceOrderId, data) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}`);
    return api.post(url, data, {
    });
  },
  async view(serviceId) {
    const url = mountUrl(`/${BASE_PATH}/view/${serviceId}`);
    return api.patch(url);
  },
};
